import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Fade, Backdrop, Modal } from '@material-ui/core';
import { getModalSwitch } from '@app/store/actions';
import CloseIcon from '@material-ui/icons/Close';
import { ModalActionsComponent } from '@app/components';

export interface IModalData {
    headerTitle: string;
    modalSwitcher?: boolean;
    localModalSwitcher?: boolean;
    form?: JSX.Element;
    modalSwitcherCallback?: Function;
    onSuccess?: Function;
    headerClasses?: string;
    bodyClasses?: string;
    primaryBtn?: string;
    secondaryBtn?: string;
    onClickPrimary?: Function;
    onClickSecondary?: Function;
    disabled?: boolean;
    buttonId?: string;
    isDeleteAction?: boolean;
    showFooter?: boolean;
    headerIcon?: 'warning' | 'destructive';
    size?: 'xs' | 'sm' | 'md' | 'lg';
}

export function ModalComponent(props: IModalData) {
    const dispatch = useDispatch();
    const modalSwitchState: boolean = useSelector((state: any) => state.modal.modalSwitcher);
    const {
        headerTitle,
        headerClasses,
        bodyClasses,
        form,
        modalSwitcherCallback,
        primaryBtn,
        secondaryBtn,
        onClickPrimary,
        onClickSecondary,
        disabled,
        buttonId,
        isDeleteAction,
        localModalSwitcher,
        showFooter,
        headerIcon,
        size = 'sm'
    } = props;

    const icon = headerIcon === 'destructive' ? 'fa-triangle-exclamation' : headerIcon === 'warning' ? 'fa-circle-exclamation' : '';
    const iconClass = headerIcon === 'destructive' ? 'modal__icon-red' : headerIcon === 'warning' ? 'modal__icon-orange' : '';
    const handleClose = () => {
        modalSwitcherCallback !== undefined ? modalSwitcherCallback(false) : dispatch(getModalSwitch(false));
    };

    const openState = () => {
        return localModalSwitcher !== undefined ? localModalSwitcher : modalSwitchState;
    };

    const handleCloseModal = (event: any, reason: any) => {
        if (reason === 'escapeKeyDown' || reason !== 'backdropClick') {
            handleClose();
        }
    };

    return (
        <Modal
            aria-labelledby='transition-modal-title'
            aria-describedby='transition-modal-description'
            className='modal'
            open={openState()}
            onClose={handleCloseModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500
            }}
        >
            <Fade in={openState()}>
                <div className={`modal__wrapper modal__wrapper-${size}`}>
                    <div className={`modal__header ${headerClasses}`}>
                        <h2>{headerIcon ? <i className={`fa-regular ${icon} ${iconClass}`} /> : null} {headerTitle}</h2>
                        <button className='modal__header-icon' onClick={handleClose}>
                            <CloseIcon />
                        </button>
                    </div>
                    <div className={`modal__body ${bodyClasses}`}>
                        {form}
                    </div>
                    {showFooter ? (
                        <ModalActionsComponent
                            primaryBtn={primaryBtn}
                            secondaryBtn={secondaryBtn}
                            onClickPrimary={onClickPrimary}
                            onClickSecondary={onClickSecondary}
                            disabled={disabled}
                            id={buttonId}
                            isDeleteAction={isDeleteAction}
                        />
                    ) : null}
                </div>
            </Fade>
        </Modal>
    );
}
